import React from 'react';
import { Box, Typography } from '@mui/material';

const GermanyTrialRegistry = () => (
  <Box sx={{ py: 3, px: 2 }}>
    <Typography variant="h5" gutterBottom>
      Germany Trial Registry (DRKS)
    </Typography>
    <Typography variant="body1" color="text.secondary">
      Capture DRKS-required data points and follow submission milestones.
    </Typography>
  </Box>
);

export default GermanyTrialRegistry;



